import { AbilityCategory } from "griptonite-api-client/types";

export function getAbilityCategoryLabel(category: AbilityCategory | null | undefined) {
  return {
    BEGINNER: "Beginner",
    NOVICE: "Novice",
    INTERMEDIATE: "Intermediate",
    ADVANCED: "Advanced",
    ELITE: "Elite",
    PROFESSIONAL: "Professional",
    "": "",
  }[category || ""];
}

export function getAbilityCategoryColor(category: AbilityCategory | null | undefined) {
  return {
    BEGINNER: "#28EE77",
    NOVICE: "#9F6000",
    INTERMEDIATE: "#d38f08ff",
    ADVANCED: "#EB5757",
    ELITE: "#9B00E4",
    PROFESSIONAL: "#010024",
    "": "#615D87",
  }[category || ""];
}
